import { getUrlMatches } from '../urlValidators/urlValidators.js';
import '../urlValidators/linkify.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const linkify = (contentState, { anchorTarget, relValue }) => {
  let lastKey = Object.keys(contentState.entityMap).length > 0 ? Math.max(...Object.keys(contentState.entityMap).map((key) => parseInt(key, 10))) + 1 : 0;
  return contentState.blocks.reduce(
    (state, block) => {
      const { text } = block;
      const linkEntries = getUrlMatches(text).filter(({ text: url, index: start, lastIndex: end }) => {
        const alreadyHasEntity = hasEntityInRange(block, start, end);
        const longEnough = url.length >= 6;
        return !alreadyHasEntity && longEnough;
      }).map(({ text: url, index: start, lastIndex: end }, idx) => {
        lastKey += idx;
        return createEntity(lastKey, url, start, end, anchorTarget, relValue);
      });
      return {
        blocks: [
          ...state.blocks,
          __spreadProps(__spreadValues({}, block), {
            entityRanges: [
              ...block.entityRanges,
              ...linkEntries.map(
                ({ entityRange }) => entityRange
              )
            ]
          })
        ],
        entityMap: __spreadValues({}, linkEntries.reduce(
          (entityMap, { mapEntry }) => __spreadValues(__spreadValues({}, entityMap), mapEntry),
          state.entityMap
        ))
      };
    },
    { blocks: [], entityMap: __spreadValues({}, contentState.entityMap) }
  );
};
const hasEntityInRange = (block, start, end) => block.entityRanges.some(({ offset, length }) => start < offset + length && end >= offset);
const createEntity = (entityKey, url, start, end, anchorTarget, relValue) => {
  const entityRange = {
    offset: start,
    length: end - start,
    key: entityKey
  };
  const mapEntry = {
    [entityKey]: {
      type: "LINK",
      mutability: "MUTABLE",
      data: {
        url,
        target: anchorTarget,
        rel: relValue
      }
    }
  };
  return { entityRange, mapEntry };
};

export { linkify };
//# sourceMappingURL=linkify.js.map
